var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.add_game_screen
        ? [
            _c("div", { staticClass: "row gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c("q-select", {
                    attrs: {
                      options: _vm.game_types
                        .filter(function(e) {
                          return e.id !== 1 && e.id !== 4
                        })
                        .map(function(e) {
                          return { label: _vm.$t(e.slug), value: e.id }
                        }),
                      disable: _vm.id_game !== 0 ? true : false,
                      "float-label": _vm.$t("game_type")
                    },
                    on: { input: _vm.changeGame },
                    model: {
                      value: _vm.game_type,
                      callback: function($$v) {
                        _vm.game_type = $$v
                      },
                      expression: "game_type"
                    }
                  })
                ],
                1
              ),
              _vm.game_type
                ? _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-alert",
                        {
                          attrs: {
                            color: "secondary",
                            icon: "fal fa-exclamation-triangle"
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getGameTypeDescription)) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c(
                    "q-field",
                    { attrs: { count: 256 } },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("title"),
                          error: _vm.$v.title.$error
                        },
                        on: { input: _vm.$v.title.$touch },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c(
                    "q-field",
                    { attrs: { count: 256 } },
                    [
                      _c("q-input", {
                        ref: "description",
                        attrs: {
                          "float-label": _vm.$t("introduction"),
                          rows: "1",
                          "max-height": 100,
                          type: "textarea",
                          error: _vm.$v.description.$error
                        },
                        on: { input: _vm.$v.description.$touch },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("q-datetime", {
                    attrs: {
                      type: "date",
                      "float-label": _vm.$t("avaliable_in"),
                      format: "DD/MM/YYYY",
                      clearable: ""
                    },
                    model: {
                      value: _vm.avaliable_in,
                      callback: function($$v) {
                        _vm.avaliable_in = $$v
                      },
                      expression: "avaliable_in"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        helper: _vm.$t("leave_it_blank_to_use_training_score")
                      }
                    },
                    [
                      _c("q-input", {
                        attrs: {
                          type: "number",
                          "float-label": _vm.$t("score"),
                          error: _vm.$v.score.$error
                        },
                        on: { input: _vm.$v.score.$touch },
                        model: {
                          value: _vm.score,
                          callback: function($$v) {
                            _vm.score = $$v
                          },
                          expression: "score"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4 text-center" },
                [
                  _c("q-checkbox", {
                    staticClass: "q-mt-md q-mr-md",
                    attrs: { val: false, label: _vm.$t("allow_to_skip_game") },
                    model: {
                      value: _vm.allow_to_skip,
                      callback: function($$v) {
                        _vm.allow_to_skip = $$v
                      },
                      expression: "allow_to_skip"
                    }
                  }),
                  _c(
                    "q-icon",
                    {
                      staticClass: "q-mr-sm q-pt-md",
                      attrs: {
                        name: "fal fa-question-circle",
                        size: "1.5rem",
                        color: "grey"
                      }
                    },
                    [
                      _c(
                        "q-tooltip",
                        {
                          staticClass: "custom-tooltip",
                          attrs: { anchor: "top left", self: "bottom right" }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("allow_to_skip_game_tooltip")) +
                              "\n\t\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              [
                _vm.selected_game
                  ? _c(_vm.selected_game, {
                      tag: "component",
                      attrs: {
                        id_game: _vm.id_game,
                        saved_game_data: _vm.game_data
                      },
                      on: {
                        save_toggle: _vm.saveToggle,
                        save_game_data: _vm.saveGameData
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "row gutter-sm q-mt-md" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("status")))
                  ]),
                  _c("q-btn-toggle", {
                    attrs: {
                      "toggle-color": _vm.getColorStatusButton,
                      options: _vm.statuses
                    },
                    model: {
                      value: _vm.status,
                      callback: function($$v) {
                        _vm.status = $$v
                      },
                      expression: "status"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("cancel")
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("back"),
                      icon: "far fa-chevron-left"
                    },
                    on: {
                      click: function($event) {
                        return _vm.returnToGames()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("save")
                },
                [
                  _c(
                    "q-btn",
                    {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        disable: !_vm.can_save,
                        label: _vm.$t("save"),
                        icon: "far fa-save"
                      },
                      on: {
                        click: function($event) {
                          return _vm.saveGame("save_game")
                        }
                      }
                    },
                    [
                      !_vm.can_save
                        ? _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.id_game
                                    ? _vm.$t("cant_update_game_tooltip")
                                    : _vm.$t("cant_save_game_tooltip")
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }